import React from "react"

function LineChart({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.5 25.5H14.5C13.0999 25.5 12.3998 25.5 11.865 25.2275C11.3946 24.9878 11.0122 24.6054 10.7725 24.135C10.5 23.6002 10.5 22.9002 10.5 21.5V10.5M13 20.5L16.3333 17.1667L19.6667 20.5L24.6667 15.5M24.6667 15.5V18.8333M24.6667 15.5H21.3333"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default LineChart
